<template>
  <div>
    <div class="container">
      <el-form label-position="center" :model="formData" :rules="rules" ref="formData" label-width="150px"
        class="demo-formData">
        <el-form-item label="证书头像照片">
          <img v-if="formData.certificateHeadPhoto" :src="formData.certificateHeadPhoto"
            style="width: 100px; height: 100px" />
          <upload v-else @handleUrl="handleUrl" />
        </el-form-item>
        <el-form-item label="单位名称">
          <span v-if="formData.schoolName" style="margin-right: 10px">{{
            formData.schoolName
          }}</span>
          <span v-if="formData.schoolId" style="
              height: 21px;
              line-height: 21px;
              border: 1px solid #6b6b6b;
              background-color: #ededed;
              color: #000;
              padding: 0 8px;
              cursor: pointer;
              display: inline-block;
            " @click="handleOrgList('修改单位', formData.schoolId)">修改单位</span>
          <span v-else style="
              height: 21px;
              border: 1px solid #6b6b6b;
              background-color: #ededed;
              padding: 0 8px;
              color: #000;
              cursor: pointer;
            " @click="handleOrgList('添加单位', undefined)">请选择单位</span>
        </el-form-item>
        <el-form-item label="单位所属地区" prop="schoolRegion">
          <el-input v-model="formData.schoolRegion" disabled placeholder="所属地区"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-input v-model="formData.realName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <div>{{ formData.gender == 1 ? "男" : "女" }}</div>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="formData.idCardNo" disabled placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="出生年月">
          <el-input v-model="formData.birthday" disabled placeholder="请输入出生年月"></el-input>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input v-model="formData.age" disabled></el-input>
        </el-form-item>
        <el-form-item label="民族">
          <el-select style="width: 100%" v-model="formData.nationality" filterable placeholder="请选择民族">
            <el-option v-for="item in json_mz" :key="item.code" :label="item.value" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="籍贯">
          <el-cascader style="width: 100%" v-model="formData.nativeCounty" :options="json_dq" :props="{
            label: 'name',
            value: 'code',
          }">
          </el-cascader>
        </el-form-item>
        <el-form-item label="政治面貌">
          <el-select style="width: 100%" v-model="formData.politicalStatus" filterable placeholder="请选择政治面貌">
            <el-option v-for="item in json_zzmm" :key="item.code" :label="item.value" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参工时间">
          <el-date-picker v-model="formData.joinWorkDate" type="date" format="yyyy-MM-dd" style="width: 100%"
            placeholder="选择参工时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学位" prop="degree">
          <span v-if="formData.degree" style="margin-right: 10px">{{
            getXw_XlName("xw", formData.degree)
          }}</span>
          <span v-if="formData.degree" style="
              height: 21px;
              line-height: 21px;
              border: 1px solid #6b6b6b;
              background-color: #ededed;
              color: #000;
              padding: 0 8px;
              cursor: pointer;
              display: inline-block;
            " @click="handleXwList('修改学位', formData.degree)">修改学位</span>
          <span v-else style="
              height: 21px;
              border: 1px solid #6b6b6b;
              background-color: #ededed;
              padding: 0 8px;
              color: #000;
              cursor: pointer;
            " @click="handleXwList('添加学位', undefined)">请选择学位</span>
        </el-form-item>
        <el-form-item label="学历" prop="educationalBackground">
          <span v-if="formData.educationalBackground" style="margin-right: 10px">{{ getXw_XlName("xl",
            formData.educationalBackground) }}</span>
          <span v-if="formData.educationalBackground" style="
              height: 21px;
              line-height: 21px;
              border: 1px solid #6b6b6b;
              background-color: #ededed;
              color: #000;
              padding: 0 8px;
              cursor: pointer;
              display: inline-block;
            " @click="handleXlList('修改学历', formData.educationalBackground)">修改学历</span>
          <span v-else style="
              height: 21px;
              border: 1px solid #6b6b6b;
              background-color: #ededed;
              padding: 0 8px;
              color: #000;
              cursor: pointer;
            " @click="handleXlList('添加学历', undefined)">请选择学历</span>
        </el-form-item>
        <el-form-item label="所属专业" prop="majorCode">
          <span v-if="formData.majorCode" style="margin-right: 10px">{{
            getXw_XlName("zy", formData.majorCode)
          }}</span>
          <span v-if="formData.majorCode" style="
              height: 21px;
              line-height: 21px;
              border: 1px solid #6b6b6b;
              background-color: #ededed;
              color: #000;
              padding: 0 8px;
              cursor: pointer;
              display: inline-block;
            " @click="handleZYList('修改专业', formData.majorCode)">修改专业</span>
          <span v-else style="
              height: 21px;
              border: 1px solid #6b6b6b;
              background-color: #ededed;
              padding: 0 8px;
              color: #000;
              cursor: pointer;
            " @click="handleZYList('添加专业', undefined)">请选择专业</span>
        </el-form-item>
        <el-form-item label="通信地址">
          <el-input placeholder="请输入通信地址" type="textarea" v-model="formData.mailAddress"></el-input>
        </el-form-item>
        <el-form-item label="人员类别" prop="personnelCategory">
          <el-select style="width: 100%" v-model="formData.personnelCategory" placeholder="请选择人员类别">
            <el-option label="国有企业工作人员" value="1"></el-option>
            <el-option label="事业单位工作人员" value="2"></el-option>
            <el-option label="非公有制单位工作人员" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职称等级" prop="professionalTitle">
          <el-select style="width: 100%" v-model="formData.professionalTitle" placeholder="请选择职称等级">
            <el-option label="未评" :value="0"></el-option>
            <el-option label="初级" :value="1"></el-option>
            <el-option label="中级" :value="2"></el-option>
            <el-option label="高级" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input v-model="formData.phoneNumber"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" v-loading="loading" @click="submitForm('formData')">
            保存
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <orgList ref="OrgList" :schoolId="formData.schoolId" @handleChage="handleSchoolChage"></orgList>
    <degreeList ref="degreeList" @handleChage="handleChage"></degreeList>
  </div>
</template>

<script>
import * as userApi from "@/api/user";
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer";
import json_mz from "@/assets/json/json_mz";
import json_xl from "@/assets/json/json_xl";
import json_xw from "@/assets/json/json_xw";
import json_zzmm from "@/assets/json/json_zzmm";
import json_dq from "@/assets/json/json_dq";
import OrgList from "@/components/orgList.vue";
import upload from "@/components/upload.vue";
import degreeList from "@/components/degreeList.vue";
import new_json_xl from "@/assets/json/new_json_xl";
import new_json_xw from "@/assets/json/new_json_xw";
import json_zy from "@/assets/json/json_zy";

export default {
  components: {
    FxedTop,
    Footer,
    OrgList,
    upload,
    degreeList,
  },
  data() {
    return {
      json_mz,
      json_xl,
      json_xw,
      json_zzmm,
      json_dq,
      new_json_xl,
      new_json_xw,
      json_zy,
      loading: false,
      formData: {
        age: undefined, // 默认年龄
        birthday: undefined, // 默认生日为当前日期
        certificateHeadPhoto: undefined, // 默认头像为空
        city: undefined, // 默认所在市
        gender: 1, // 默认性别为男
        idCardNo: undefined, // 默认身份证号
        mailingAddress: undefined, // 默认通信地址
        majorSeries: undefined, // 默认所属专业系列
        nationality: undefined, // 默认民族
        nativePlace: undefined, // 默认籍贯
        officePhone: undefined, // 默认办公电话
        personnelCategory: undefined, // 默认人员类别
        phoneNumber: undefined, // 默认手机号
        politics: undefined, // 默认政治面貌
        professionalTitle: undefined, // 默认职称等级
        province: undefined, // 默认所在省
        realName: undefined, // 默认真实姓名
        region: undefined, // 默认所在区/县
        userToken: undefined, // 默认用户TOKEN
        workCurrentTime: undefined, // 默认任现职时间为当前日期
        joinWorkDate: undefined, // 默认参加工作时间为当前日期
        workUnit: undefined, // 默认工作单位
        workUnitTier: undefined, // 默认单位所属地区层级
        email: undefined, // 邮箱
        schoolId: undefined,
        degree: undefined,
        educationalBackground: undefined,
      },
      rules: {
        realName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        idCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        degree: [{ required: true, message: "请输入学位", trigger: "blur" }],
        educationalBackground: [
          { required: true, message: "请选择学历", trigger: "blur" },
        ],
        professionalTitle: [
          { required: true, message: "请选择职称等级", trigger: "blur" },
        ],
        phoneNumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getXw_XlName(type, code) {
      let name = "";
      if (type == "xw") {
        this.new_json_xw.forEach((item) => {
          if (item.code == code) {
            name = item.value;
          }
          if (item.isParent) {
            item.sub.forEach((itemm) => {
              if (itemm.code == code) {
                name = itemm.value;
              }
            });
          }
        });
      }
      if (type == "xl") {
        this.new_json_xl.forEach((item) => {
          if (item.code == code) {
            name = item.value;
          }
          if (item.isParent) {
            item.sub.forEach((itemm) => {
              if (itemm.code == code) {
                name = itemm.value;
              }
            });
          }
        });
      }
      if (type == "zy") {
        this.json_zy.forEach((item) => {
          if (item.code == code) {
            name = item.value;
          }
          if (item.sub.length > 0) {
            item.sub.forEach((itemm) => {
              if (itemm.code == code) {
                name = itemm.value;
              }
              if (itemm.sub.length > 0) {
                itemm.sub.forEach((itemmm) => {
                  if (itemmm.code == code) {
                    name = itemmm.value;
                  }
                });
              }
            });
          }
        });
      }
      return name;
    },
    handleXwList(title, code) {
      this.$refs.degreeList.show("xw", title, code);
    },
    handleXlList(title, code) {
      this.$refs.degreeList.show("xl", title, code);
    },
    handleZYList(title, code) {
      this.$refs.degreeList.show("zy", title, code);
    },
    handleChage(item) {
      if (item.type == "xw") {
        this.formData.degree = item.code;
      }
      if (item.type == "xl") {
        this.formData.educationalBackground = item.code;
      }
      if (item.type == "zy") {
        this.formData.majorCode = item.code;
      }
      this.$forceUpdate();
    },
    handleSchoolChage(item) {
      this.formData.schoolId = item.orgId;
      this.formData.schoolName = item.orgName;
    },
    handleOrgList(title, schoolId) {
      this.$refs.OrgList.show(title, schoolId);
    },

    handleUrl(url) {
      this.formData.certificateHeadPhoto = url;
      this.$forceUpdate();
    },
    // 地区选择
    changeSelectRegion(value) {
      this.formData.province = value.provinceName;
      this.formData.city = value.cityName;
      this.formData.region = value.countyName;
      this.formData.areaId = value.areaId;
    },
    async getUserInfo() {
      try {
        let res = await userApi.getUserInfo();
        if (res.code == 200) {
          if (res.data.nativeCounty) {
            res.data.nativeCounty = JSON.parse(res.data.nativeCounty);
          }
          this.formData = res.data;
        }
      } catch (error) { }
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;

          if (this.formData.joinWorkDate) {
            this.formData.joinWorkDate = formatDateToYYYYMMDD(
              this.formData.joinWorkDate
            );
          }

          const res = await userApi.completeUserInfo({
            ...this.formData,
            regionId: undefined,
            nativeCounty: this.formData.nativeCounty
              ? JSON.stringify(this.formData.nativeCounty)
              : undefined,
          });
          const user = await userApi.getUserInfo();
          localStorage.setItem("userInfo", JSON.stringify(user.data));
          if (res.code == 200) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.loading = false;
        } else {
          return false;
        }
      });
    },
  },
};
function formatDateToYYYYMMDD(isoString) {
  // 如果已经是 YYYY-MM-DD 格式，直接返回
  if (/^\d{4}-\d{2}-\d{2}$/.test(isoString)) {
    return isoString;
  }
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 20px;
}

.demo-formData {
  background: #fff;
  // 阴影
  box-shadow: 2px 2px 10px 0 rgba(255, 255, 255, 0.1);
  padding: 40px;

  .title {
    font-size: 18px;
    margin-bottom: 20px;
  }
}

.btn {
  padding: 5px 40px;
  background: linear-gradient(180deg, #41a0f1 0%, #0a5b9f 100%);
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
  border-radius: 5px;
  text-align: center;
  line-height: 30px;
  border: none;
  cursor: pointer;
}
</style>
